import _Map from "@babel/runtime-corejs2/core-js/map";
import { css } from 'styled-components';
import { Colors } from '../consts/palette.const';
import { warning } from '@origin-digital/helper';
var colorLabelMap = new _Map([['redPink', Colors.RED_PINK], ['red', Colors.RED], ['orange', Colors.ORANGE], ['lightOrange', Colors.LIGHT_ORANGE], ['lightBlue', Colors.LIGHT_BLUE], ['grey', Colors.GREY], ['lightGrey', Colors.LIGHT_GREY], ['blue', Colors.BLUE], ['green', Colors.GREEN], ['lightGreen', Colors.LIGHT_GREEN], ['purple', Colors.PURPLE], ['grey4', Colors.GREY4], ['grey8', Colors.GREY8], ['grey16', Colors.GREY16], ['grey24', Colors.GREY24], ['grey48', Colors.GREY48], ['grey80', Colors.GREY80], ['grey56', Colors.GREY56], ['white', Colors.WHITE], ['black', Colors.BLACK], ['transparent', Colors.TRANSPARENT]]);
/**
 * Maps readable style guide color labels:
 *
 * export type ColorLabels = | 'redPink' | 'red' | 'orange' |
 * 'lightOrange' | 'lightBlue' | 'grey' | 'lightGrey' | 'blue' |
 * 'green' | 'lightGreen' | 'purple' | 'grey4' | 'grey8' | 'grey16' |
 * 'grey24' |'grey48' | 'grey80' | 'grey56' | 'white' | 'black' |
 * 'transparent';
 *
 * to our style guide color palette Colors enum:
 *
 * export enum Colors { RED_PINK = '#ff373c', RED = '#ec0000', ORANGE
 * = '#ff8228', LIGHT_ORANGE = '#ffb432', LIGHT_BLUE = '#d2f0ff', GREY
 * = '#505050', LIGHT_GREY = '#535353', BLUE = '#3f75c6', GREEN =
 * '#008906', LIGHT_GREEN = '#a5bb48', PURPLE = '#c34789', GREY4 =
 * '#f8f8f8', GREY8 = '#f1f1f1', GREY16 = '#e3e3e3',  GREY24 = '#d5d5d5',
 * GREY48 = '#ababab', GREY80 = '#737373', GREY56 = '#232323', WHITE =
 * '#ffffff', BLACK = 'black', TRANSPARENT = 'transparent'
 * }
 *
 * @returns hex color of the colorLabel.
 * @param colorLabel
 */

export var mapColorLabelToHex = function mapColorLabelToHex(colorLabel) {
  // If no color is provided, use the default.
  process.env.NODE_ENV !== "production" ? warning(!!colorLabel, "Style guide: a colorLabel must be provided \u26D4\uFE0F") : void 0;
  var hex = colorLabelMap.get(colorLabel);
  process.env.NODE_ENV !== "production" ? warning(!!hex, "Style guide: ".concat(colorLabel, " is not a colorLabel that I am aware about \uD83E\uDD14")) : void 0;
  return hex;
};
export var backgroundColor = function backgroundColor() {
  return css(["", ";"], function (_ref) {
    var color = _ref.color;
    return "background-color: ".concat(mapColorLabelToHex(color), ";");
  });
};
export var color = css(["", ";"], function (_ref2) {
  var color = _ref2.color;
  return "color: ".concat(mapColorLabelToHex(color), ";");
});